import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { SezioneFatture } from '../../../models/sezioni/sezione-fatture';
import { FattureAddComponent } from './fatture-add.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [fattura-mod-add]',
  templateUrl: 'fattura-mod-add.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class FatturaModAdd {
  @Output() onReturn: EventEmitter<SezioneFatture> = new EventEmitter<SezioneFatture>();
  @ViewChild('formFatturaAdd') formFattura: FattureAddComponent;

  inizializza(idSezione: string, idFascicolo: string, idSezioneAltreParti: string, urlInsert: string, urlReadSezioneAltreParti: string) {
    this.formFattura.inizializza(idSezione, idFascicolo, idSezioneAltreParti, urlInsert, urlReadSezioneAltreParti);
    openModal('modaladdFattura');
  }

  createForm() {
    this.formFattura.createForm();
    this.formFattura.setTextEmpty();
  }

  manageModal(sezioneFatture: SezioneFatture) {
      closeModal('modaladdFattura');
      this.onReturn.emit(sezioneFatture);
  }
}
